import React, { useState, useContext } from 'react';
import { Link, useNavigate, useParams, useOutletContext } from 'react-router-dom';
import AuthContext from './AuthContext';
import LoadingSpinner from './LoadingSpinner';
import './LoginForm.css';

const LoginForm = () => {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const { dataClient } = useOutletContext();
  const { login, user } = useContext(AuthContext); // Access user from AuthContext

  const [formData, setFormData] = useState({
    login: '',
    password: '',
    customer_id: customerId,
    role_name: '',
    active: ''
  });

  if (!dataClient) {
    return <LoadingSpinner />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // WEST-796: the identifier may be a username or an email address. Trim it here so a
      // pasted value with stray spaces still matches; the server normalises again regardless.
      const payload = { ...formData, login: formData.login.trim() };
      if (!payload.login || !payload.password) {
        alert('Please enter your username or email and your password.');
        return;
      }
      const response = await fetch(`${process.env.REACT_APP_PROXY_URL}/api/customer/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const token = data.token;
      if (!token) {
        throw new Error('No token in login response');
      }

      // Store token and update AuthContext
      login(token, Boolean(data.emailRequired)); // Login updates the user state

      // Retrieve role_name from localStorage
      const roleName = localStorage.getItem('role_name');
      const userId = localStorage.getItem('id');

      // WEST-794: no email on file → the only place they can go is their own profile.
      if (data.emailRequired) {
        navigate(`/customer/${customerId}/user/manage/${userId}`);
        return;
      }

      // Evaluate role_name
      if (roleName === 'Admin' || roleName === 'SuperAdmin') {
        navigate(`/customer/${customerId}/client/list`);
        
      } else if (roleName === 'User') {
        navigate(`/customer/${customerId}/user/manage/${userId}`);
      } else {
        alert('Unauthorized role. Contact support.');
      }
    } catch (error) {
      console.error('Error during login:', error.message);
      alert('Login failed. Please check your credentials and try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <table
        className="tableMain"
        border="0"
        width="100%"
        cellPadding="2"
        cellSpacing="2"
      >
        <tbody>
          <tr>
            <td className="lbltxt">Username or email:</td>
            <td>
              <input
                className="fieldsSm"
                type="text"
                name="login"
                autoComplete="username"
                required
                value={formData.login}
                onChange={handleChange}
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Password:</td>
            <td>
              <input
                className="fieldsSm"
                type="password"
                name="password"
                autoComplete="current-password"
                required
                value={formData.password}
                onChange={handleChange}
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <input
                type="submit"
                name="LoginSubmit"
                value="login"
                id="login"
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              {/* WEST-599 */}
              <Link to={`/customer/${customerId}/forgot-password`}>Forgot your password?</Link>
            </td>
          </tr>
        </tbody>
      </table>
      <input name="customer_id" type="hidden" value={formData.customer_id} />
    </form>
  );
};

export default LoginForm;